import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import ProAddressRow from './ProAddressRow';
import FormTitle from '../../../library/form/components/FormTitle'
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormButton from '../../../library/form/components/FormActionButton2';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../library/layout/Index";

const ProAddress = (props) => {
    const { formObject, viewData } = props;
    if (!viewData)
        return (null)
    else {
        return (
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span>
                            <FormTitle formObject={formObject} value='Available Addresses' />
                        </span>
                    </UiTitle>
                    <UiAction>
                        <FormButton formObject={formObject} id="newAddButton" ksc="a" rowKey="" starIcon={"adds"}
                            action={{ actionId: "new",  actionParam: {}, containerKey: "popup" }}
                            className="uiActionIconButton" text={<SarasTrans value="Add Address" />}></FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    {
                        Object.values(viewData).map((row, index) => (
                            <ProAddressRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                        ))
                    }
                </UiViewContent>
            </UiView>
        )
    }
}

export default withView(ProAddress, "proAddress", "proAddress")